// This file contains constants and logic to return UI features such as
// colors and icons based on locker/hub properties

import _ from 'lodash';
import { Kiosk } from '../../../ui/components/pure/icons/Kiosk.icon';
import { LockerDC } from '../../../ui/components/pure/icons/LockerDC.icon';
import { LockerL } from '../../../ui/components/pure/icons/LockerL.icon';
import { LockerLR } from '../../../ui/components/pure/icons/LockerLR.icon';
import { LockerM } from '../../../ui/components/pure/icons/LockerM.icon';
import { LockerMR } from '../../../ui/components/pure/icons/LockerMR.icon';
import { LockerS } from '../../../ui/components/pure/icons/LockerS.icon';
import { LockerTL } from '../../../ui/components/pure/icons/LockerTL.icon';
import { LockerXL } from '../../../ui/components/pure/icons/LockerXL.icon';
import { LockerXLH } from '../../../ui/components/pure/icons/LockerXLH.icon';
import { LockerXS } from '../../../ui/components/pure/icons/LockerXS.icon';
import { LockerXXXL } from '../../../ui/components/pure/icons/LockerXXXL.icon';
import { Space } from '../../../ui/components/pure/icons/Space.icon';
import { Colors } from '../../../ui/theme/colors';
import { ExpectedLockerSize } from './types';

const lockerSizeOrder = [
  'kiosk',
  'space',
  'xs',
  'extra small',
  's',
  'small',
  'm',
  'medium',
  'l',
  'large',
  'mf',
  'medium fridge',
  'lf',
  'large fridge',
  'tl',
  'tall',
  'dc',
  'dry cleaning',
  'xl',
  'extra large',
  'xlh',
  'xl/hanging',
  'xxxl'
];

export function sortByLockerSize<T extends string | object>(list: T[], get: (el: T) => string) {
  return _.sortBy(list, (el) => {
    const size = get(el).toLowerCase();
    const position = lockerSizeOrder.indexOf(size as ExpectedLockerSize);
    return position === -1 ? Number.MAX_SAFE_INTEGER : position;
  });
}

export function lockerSizeToLockerIconMap(isKiosk: boolean, size?: string) {
  if (isKiosk) {
    return Kiosk;
  }
  switch (size?.toLowerCase()) {
    case 'xs':
    case 'extra small':
      return LockerXS;
    case 's':
    case 'small':
      return LockerS;
    case 'm':
    case 'medium':
      return LockerM;
    case 'l':
    case 'large':
      return LockerL;
    case 'xl':
    case 'extra large':
      return LockerXL;
    case 'dc':
    case 'dry cleaning':
      return LockerDC;
    case 'mf':
    case 'medium fridge':
      return LockerMR;
    case 'lf':
    case 'large fridge':
      return LockerLR;
    case 'tl':
    case 'tall':
      return LockerTL;
    case 'xlh':
    case 'xl/hanging':
      return LockerXLH;
    case 'xxxl':
      return LockerXXXL;
    case 'space':
      return Space;
    default:
      return undefined;
  }
}

export const hubStatusColorMap: Record<string, string> = {
  active: Colors.collectedGreen,
  disabled: Colors.cancelledDeletedRed
};

export function lockerSizeToLockerIconColorMap(size: string) {
  switch (size.toLowerCase()) {
    case 'xs':
    case 'extra small':
      return '#A16EC6';
    case 's':
    case 'small':
      return 'rgb(9, 155, 140)';
    case 'm':
    case 'medium':
      return 'rgb(218, 86, 16)';
    case 'l':
    case 'large':
      return 'rgb(255, 189, 2)';
    case 'xl':
    case 'extra large':
      return 'rgb(8, 47, 116)';
    case 'dc':
    case 'dry cleaning':
      return 'rgb(214, 23, 28)';
    case 'mf':
    case 'medium fridge':
      return '#36AFFA';
    case 'lf':
    case 'large fridge':
      return '#0185E3';
    case 'tl':
    case 'tall':
      return 'rgb(214, 23, 28)';
    case 'xlh':
    case 'xl/hanging':
      return 'rgb(8, 47, 116)';
    case 'xxxl':
      return '#6A3391';
    case 'space':
      return '#475361';
    default:
      return undefined;
  }
}
